import CreateUpdateDebtorForm from "./CreateUpdateDebtorForm";

export default function CreateDebtor() {
  return (
    <>
      <CreateUpdateDebtorForm />
    </>
  );
}

